import { Box, Flex } from '~/components/layout'
import { Heading, Text } from '~/components/typography'
import { colors } from '~/styles/colors'
import { Avatar } from '~/components/avatar'
import { PageBySlugQuery } from '~/graphql/page-by-slug'

type Props = {
  fundraiser: PageBySlugQuery['pageBySlug']['fundraisers'][0]
}

const FundraiserAbout = ({ fundraiser }: Props) => {
  return (
    <Box paddingBottom={56} marginBottom={56} borderBottom={colors.border}>
      <Flex alignItems="center" marginBottom={20}>
        {fundraiser.profilePictureUrl && (
          <Avatar
            size={56}
            user={{ profilePictureUrl: fundraiser.profilePictureUrl }}
            marginRight={16}
          />
        )}
        <Heading level={4}>{fundraiser.name}</Heading>
      </Flex>
      <Text style={{ whiteSpace: 'pre-line' }}>{fundraiser.description}</Text>
    </Box>
  )
}

export default FundraiserAbout
